export default {
  name: "KisOverview",
  data: () => ({}),
  async mounted() {},
  methods: {
    goTo(path) {
      this.$router.push(path);
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isKisUser() {
      return this.isKisAdmin || this.currentUser?.scopes?.includes("role:kis");
    },
    isKisAdmin() {
      return (
        this.isAdmin || this.currentUser?.scopes?.includes("role:kis_admin")
      );
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    }
  }
};
